module.exports = __webpack_public_path__ + "img/Dashboard.99d9c751.svg";